import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewMotorPredefined } from "../../utils/backend";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatDateTime } from "../../components/FormattedTime/FormatDateTime";
import { CDropdown, CDropdownToggle } from "@coreui/react-pro";

const ViewMotorProduct = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [plan, setPlan] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const response = await viewMotorPredefined({ id: id });
      console.log(response);
      setPlan(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPlan({});
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/motor-insurance");
  };

  return (
    <>
      {/* <h5 className='mb-3'>Admin Details</h5> */}
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton
                height={40}
                width={100}
                style={{ marginRight: "10px" }}
              />
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-light">
          <div className="card-body p-4">
            <label className="form-label">Plan Details</label>
            <div
              className="p-4 mb-4 rounded"
              style={{ backgroundColor: "#F8F9FA" }} // Light grey/purple background
            >
              <h5 className="fw-bold mb-4">{plan?.plan_name}</h5>

              <div className="row mb-4">
                <div className="col-md-6 mb-3 mb-md-0">
                  <label className="form-label text-muted">
                    Upload Policy disclosure sheet document (PDF)
                  </label>
                  <div>
                    <a
                      href={plan?.pds_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-success text-decoration-underline"
                      style={{ wordBreak: "break-all" }}
                    >
                      {plan?.product_disclosure_sheet_url}
                    </a>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label text-muted">
                    Upload Policy wording document (PDF)
                  </label>
                  <div>
                    <a
                      href={plan?.policy_wording_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-success text-decoration-underline"
                      style={{ wordBreak: "break-all" }}
                    >
                      {plan?.policy_wording_url}
                    </a>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label text-muted">Plan Benefits</label>
                <div className="d-flex flex-column">
                  {plan?.plan_benefits &&
                    plan.plan_benefits.map((benefit, index) => (
                      <span key={benefit.id || index} className="fw-bold">
                        {benefit.benefit_description}
                      </span>
                    ))}
                </div>
              </div>

              <div>
                <label className="form-label text-muted">Add-ons</label>
                <div className="d-flex flex-column">
                  {(plan?.add_ons &&
                    plan?.add_ons.length > 0 &&
                    plan.add_ons.map((add_on, index) => (
                      <span key={add_on.id || index} className="fw-bold">
                        {add_on.add_on_name}
                      </span>
                    ))) ||
                    "N/A"}
                </div>
              </div>
            </div>

            <div className="card-body p-4">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Vechicle Type</label>
                  <p>
                    <b>{plan?.veh_type}</b>
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Insurance Name</label>
                  <p>
                    <b>{plan?.insurance_name}</b>
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Plan Status</label>
                  <p>
                    <CDropdown>
                      <CDropdownToggle
                        color="secondary"
                        variant="outline"
                        style={{
                          backgroundColor:
                            plan.plan_status === 0
                              ? "#A9A9A9"
                              : plan.plan_status === 1
                              ? "#66BB6A"
                              : "#FFFFFF",
                          color: "#fff",
                          border: "none",
                          width: "160px",
                          fontSize: "14px",
                          borderRadius: "20px",
                          fontWeight: "500",
                        }}
                      >
                        {plan.plan_status === 1 ? "Active" : "Inactive"}
                      </CDropdownToggle>
                    </CDropdown>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Last Updated</label>
                  <p>
                    <b>{formatDateTime(plan.updated_at)}</b>
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Created At</label>
                  <p>
                    <b>{formatDateTime(plan.created_at)}</b>
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn me-3 ansa-button-secondary"
                  onClick={handleBackClick}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn ansa-button-primary"
                  onClick={() => navigate(`/motor-insurance/edit/${id}`)}
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewMotorProduct;
